export default "__VITE_ASSET__EvZjf0hV__"